import { TextLink } from '@cellula/react';
import { AsyncSignal } from '@cortex-shim/async_signal.component';
import { useResolveController } from '@visiba/instantiation';
import { FooterController } from './footer.controller';

export function ExternalLink() {
	const controller = useResolveController(FooterController);

	return (
		<AsyncSignal signal={controller.data}>
			{({ externalLink }) => (
				<>
					{externalLink ? (
						<TextLink href={externalLink.url} icon='network'>
							{externalLink.name ?? ''}
						</TextLink>
					) : null}
				</>
			)}
		</AsyncSignal>
	);
}
